import {
    Show,
    SimpleShowLayout,
    NumberField,
    TextField,
} from 'react-admin';
import { AdRewards } from '../AdRewards';
import { Payouts } from '../Payouts';
import { CountryName } from '../CountryName';

export const UserShow = () => (
    <Show>
    <SimpleShowLayout>
    <TextField source="id" />
    <TextField source="email" />
    <TextField source="role" />
    <NumberField source="age" />
    <TextField source="country" />
    <TextField source="dark_mode" />
    <TextField source="display_name" />
    <TextField source="email" />
    <TextField source="last_settings_refresh_date" />
    <TextField source="lifetime_ads_watched" />
    <TextField source="lifetime_tokens_earned" />
    <TextField source="lifetime_usd_earnings" />
    <TextField source="lifetime_usd_payouts" />
    <TextField source="redeemable_tokens" />
    <TextField source="todays_ad_count" />
    <TextField source="token_balance" />
    <TextField source="tokens_earned_today" />
    <TextField source="total_referred_active_users" />
    <TextField source="uid" />
    <TextField source="banked_tokens_today" />
    <TextField source="consecutive_streak_days" />
    <TextField source="balance_usd" />
    <TextField source="created_time" />
    
    <h3>Country</h3>
    <CountryName />

    <h3>Ad Rewards</h3>
    <AdRewards />
    
    <h3>Payouts</h3>
    <Payouts />
    
    </SimpleShowLayout>
    </Show>
);
